/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import type { ProjectPermissions } from './ProjectPermissions.types.tsx';

const RESOURCE_TYPE_PROJECT_PERMISSIONS = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';

export const projectCreatePermissionsResource: RouteResource<ProjectPermissions | null> =
	createResource<ProjectPermissions | null>({
		type: RESOURCE_TYPE_PROJECT_PERMISSIONS,
		getKey: () => 'state',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-project-permissions", jiraSpaEntry: "async-resource-project-permissions" */ './getData.tsx'
			),
		maxAge: Infinity,
	});

export const useProjectCreatePermissionsResource =
	(): UseResourceHookResponse<ProjectPermissions | null> =>
		useResource<ProjectPermissions | null>(projectCreatePermissionsResource);
